import { TimelineMax, TweenMax, Expo } from 'gsap'
import SplitText from '@/assets/lib/SplitText'

const transition = (dir, fromMenu, callback) => {
  const tl = new TimelineMax({
    delay: fromMenu ? 0.9 : 0,
    onComplete: () => {
      if (dir === 'in') {
        TweenMax.set('[data-arrows-hero] .prev', { pointerEvents: 'auto' })
        TweenMax.set('[data-arrows-hero] .next', { pointerEvents: 'auto' })
      }
      callback()
    }
  })
  const prop = dir === 'out' ? 'staggerTo' : 'staggerFrom'
  let els = Array.from(document.querySelectorAll('.title-chars'))

  if (els.length === 0) {
    const split = new SplitText(
      document.querySelector('[data-title]'),
      { type: 'words, chars', charsClass: 'title-chars' }
    )
    els = split.chars
  }

  tl.addLabel('start')
    .set('#smoothie', { autoAlpha: 1, y: 0 }, 'start')
    .to('[data-arrows-hero] .prev', 0.05, {
      pointerEvents: 'none'
    }, 'start').to('[data-arrows-hero] .next', 0.05, {
      pointerEvents: 'none'
    }, 'start')[prop](els, 1.2, { // eslint-disable-line
      yPercent: 20,
      rotationZ: 20,
      rotationY: 80,
      autoAlpha: 0,
      ease: Expo.easeInOut
    }, 0.03, 'start+=0.05')

  return tl
}

export default transition



// WEBPACK FOOTER //
// ./src/scripts/transitions/slide.js